import { isActiveAccount } from "@/common/helpers/analyticsSettings.helper"
import AccountService from "@/services/AccountService"
import { getUserAccounts } from "@/services/UserService"

export const fetchAccounts = async ({ commit }) => {
  const accounts = await getUserAccounts()

  commit("setAccounts", accounts)

  return accounts
}

export const fetchAccount = async ({ commit }, id) => {
  const account = await AccountService.getAccount(id)

  commit("setAccount", account)

  return account
}

export const updateAccount = async ({ commit }, data) => {
  const account = await AccountService.updateAccount(data)

  commit("setAccount", account)

  return account
}

export const suspendAccount = async ({ commit }, id) => {
  const account = await AccountService.suspendAccount(id)

  commit("setAccount", account)

  return account
}

export const reactivateAccount = async ({ commit }, id) => {
  const account = await AccountService.reactivateAccount(id)

  commit("setAccount", account)

  return account
}

export const fetchAnalyticsSettings = async ({ commit, state }, accountKey) => {
  let includeBots = false

  try {
    const settings = await AccountService.getAccountAnalyticsSettings(accountKey)

    includeBots = Boolean(settings && settings.includeBots)
  } catch (e) {
    console.log(e)
    // Not being able to read the setting must not break account loading;
    // fall back to the default (bots excluded).
  }

  // The account may have been switched while the request was in flight.
  if (isActiveAccount(accountKey, state.account.key)) {
    commit("setAnalyticsSettings", { accountKey, includeBots })
  }
}

export const updateAnalyticsSettings = async ({ commit, state }, settings) => {
  const accountKey = state.account.key
  const saved = await AccountService.updateAccountAnalyticsSettings(accountKey, settings)

  if (isActiveAccount(accountKey, state.account.key)) {
    commit("setAnalyticsSettings", { accountKey, includeBots: saved && saved.includeBots })
  }

  return saved
}

export const deleteAccount = async ({ dispatch }, id) => {
  await AccountService.deleteAccount(id)

  dispatch("resetAccount")
}

export const resetAccount = async ({ commit }) => {
  commit("reset")
  commit("AccountPeople/reset", [], { root: true })
  commit("AccountStations/reset", [], { root: true })
  commit("AccountSubscriptions/reset", [], { root: true })
  commit("Campaign/reset", [], { root: true })
  commit("Station/reset", [], { root: true })
  commit("Analytics/reset", [], { root: true })
  commit("PodcastsAnalytics/reset", [], { root: true })
  commit("Finance/reset", [], { root: true })
  commit("Episode/reset", [], { root: true })
  commit("Podcast/reset", [], { root: true })
  commit("Subscription/reset", [], { root: true })
  commit("FeatureFlags/reset", [], { root: true })
  commit("ProfilePosts/reset", [], { root: true })
}
